import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import {
  HotelSmallReservationComponent
} from '@shared/small-reservation-detail/components/hotel-small-reservation/hotel-small-reservation.component';
import {
  FlightSmallReservationComponent
} from '@shared/small-reservation-detail/components/flight-small-reservation/flight-small-reservation.component';
import { FlightItineraryModule } from '@shared/flight-itinerary/flight-itinerary.module';
import {
  AssistanceSmallReservationComponent
} from '@shared/small-reservation-detail/components/assistance-small-reservation/assistance-small-reservation.component';
import { CopyToClipboardModule } from '@ux/components/copy-to-clipboard/copy-to-clipboard.module';
import { StatusReservationTypeModule } from '@ux/components/status-reservation-type/status-reservation-type.module';
import {
  ExtraSmallReservationComponent
} from '@shared/small-reservation-detail/components/extra-small-reservation/extra-small-reservation.component';
import { BusItineraryModule } from '@shared/bus-itinerary/bus-itinerary.module';
import {
  BusSmallReservationComponent
} from '@shared/small-reservation-detail/components/bus-small-reservation/bus-small-reservation.component';
import {
  VehicleSmallReservationComponent
} from '@shared/small-reservation-detail/components/vehicle-small-reservation/vehicle-small-reservation.component';
import { BtnLoaderModule } from '@ux/components/btn-loader/btn-loader.module';
import {
  SmallReservationDateInfoComponent
} from './components/small-reservation-date-info/small-reservation-date-info.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { GenericCardDsComponent } from '@design-system/components/templates/generic-card/generic-card.component';

@NgModule({
  declarations: [
    HotelSmallReservationComponent,
    FlightSmallReservationComponent,
    AssistanceSmallReservationComponent,
    ExtraSmallReservationComponent,
    BusSmallReservationComponent,
    VehicleSmallReservationComponent,
    SmallReservationDateInfoComponent,
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    FlightItineraryModule,
    CopyToClipboardModule,
    StatusReservationTypeModule,
    BusItineraryModule,
    BtnLoaderModule,
    TypographyDsComponent,
    IconDsComponent,
    GenericCardDsComponent,
  ],
  exports: [
    HotelSmallReservationComponent,
    FlightSmallReservationComponent,
    AssistanceSmallReservationComponent,
    ExtraSmallReservationComponent,
    BusSmallReservationComponent,
    VehicleSmallReservationComponent,
    SmallReservationDateInfoComponent
  ],
  providers: [
    DatePipe
  ]
})
export class SmallReservationDetailModule { }
